import React from 'react';

const Modal = ({ isOpen, onClose, children, hideCloseButton = false }) => {
    return (
        <div className={`modal-overlay ${isOpen ? 'active' : ''}`} onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                {!hideCloseButton && <button className="modal-close" onClick={onClose}>&times;</button>}
                {children}
            </div>
        </div>
    );
};

export default Modal;
